import { SubProject } from './models';

export class Project {
  projectId: number;
  subProjects: SubProject[];
}

